<template src="./VerifySmsComponent.html"></template>
<script>
import SIGN_IN_STAGE from '../../model/SignInStage';
import PinCodeComponent from '../PinCodeComponent/PinCodeComponent';
import { SMS_CODE_LENGTH } from '@/constants';
import Checkbox from 'primevue/checkbox';
import * as Sentry from '@sentry/vue';
import {getSupportedBrowserLanguage} from "@bnr-dev/translate";

export default {
    components: {
        PinCodeComponent,
        Checkbox
    },
    inject: ['authService', 'tokenService'],
    props: {
        email: {
            type: String,
            required: true
        },
        // eslint-disable-next-line vue/require-default-prop
        phone: {
            type: String,
            required: false
        },
        // eslint-disable-next-line vue/require-default-prop
        pin: {
            type: String
        },
        // eslint-disable-next-line vue/require-default-prop
        phoneMask: {
            type: String
        },
        isSignIn: {
            type: Boolean,
            default: true
        }
    },
    emits: ['code-entered'],
    data() {
        return {
            smsCode: null,
            errorMessage: null,
            smsResent: false,
            showLoadingSpinner: false,
            resendSmsAttempts: 0,
            smsResendWaitTimeInSeconds: NaN,
            smsResendWaitIntervalId: NaN
        };
    },
    mounted() {
        this.onSmsSent();
    },
    computed: {
        SMS_CODE_LENGTH: () => SMS_CODE_LENGTH
    },
    methods: {
        showErrorMessage(error) {
            if (error && error.json && error.json.errorCode) {
                this.errorMessage = this.$t(
                    'error-codes.' + error.json.errorCode
                );
            } else {
                this.errorMessage = this.$t(
                    'generic.unexpected-error-occurred'
                );
                Sentry.withScope((scope) => {
                    scope.setExtra('error', error);
                    Sentry.captureMessage('Unexpected error');
                });
            }
        },
        onSmsCodeInput(smsCode) {
            this.smsCode = smsCode;
            if (smsCode.length === SMS_CODE_LENGTH) {
                this.$emit('code-entered', smsCode);

                if (this.isSignIn) {
                    this.showLoadingSpinner = true;
                    this.errorMessage = '';

                    this.authService
                        .verifyOtcCode(this.email, smsCode)
                        .then((signInResponse) => {
                            console.log('verifyOtcCode response', signInResponse);
                            this.errorMessage = '';
                            this.resendSmsAttempts = 0;
                            // success handling not needed as user will be signed in and redirected to another page
                        })
                        .catch(this.handleVerifyOtcErrorResponse.bind(this))
                        .finally(() => {
                            this.showLoadingSpinner = false;
                        });
                }
            }
        },
        handleVerifyOtcErrorResponse(error) {
            this.smsCode = ''; // Setting smsCode empty causes pin code component to clear
            this.showErrorMessage(error);
            this.smsResent = false;
        },
        onResendSmsClicked() {
            this.showLoadingSpinner = true;
            const languageCode = getSupportedBrowserLanguage();

            if (this.isSignIn) {
                this.authService
                    .signIn(this.email, this.pin, languageCode)
                    .then(() => this.onSmsSent(true))
                    .catch((error) => {
                        this.smsResendWaitTimeInSeconds = NaN;
                        this.currentStage = SIGN_IN_STAGE.PIN;
                        this.handleVerifyOtcErrorResponse(error);
                    })
                    .finally(() => {
                        this.showLoadingSpinner = false;
                    });
            } else {
                this.authService.requestPhoneVerification(this.email, this.phone, languageCode)
                    .then(() => this.onSmsSent(true))
                    .catch(() => {
                        this.handleVerifyOtcErrorResponse();
                    })
                    .finally(() => {
                        this.showLoadingSpinner = false;
                    });
            }
        },
        onSmsSent(isResent) {
            this.smsResent = !!isResent;
            this.resendSmsAttempts++;
            this.smsResendWaitTimeInSeconds = this.getSmsResendWaitTimeInSeconds();
            this.smsResendWaitIntervalId = window.setInterval(this.expireSmsResendWait, 1000);
        },
        getSmsResendWaitTimeInSeconds() {
            return 30 * this.resendSmsAttempts;
        },
        expireSmsResendWait() {
            if (this.smsResendWaitTimeInSeconds && this.smsResendWaitTimeInSeconds > 1) {
                this.smsResendWaitTimeInSeconds--;
                return;
            }

            this.smsResendWaitTimeInSeconds = NaN;
            window.clearInterval(this.smsResendWaitIntervalId);
        }
    }
};
</script>

<style scoped lang="scss" src="./VerifySmsComponent.scss"></style>
